import styles from "../landing-page-four.module.css";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";

export const BenefitsSection = () => {
  const benefits: Array<{
    title: string;
    description: string;
    icon: UIIconName;
  }> = [
    // {
    //   title: "Multiple File Formats",
    //   description: "Upload GPX, TCX, KML, or FIT files from any GPS device or fitness app"
    // },
    // {
    //   title: "High Resolution Output",
    //   description: "300 DPI print-ready files ensure crisp, professional quality posters"
    // },
    {
      title: "No need for GPX files",
      description:
        "Use our app to upload routes from tracked activities, or create routes from your photos",
      icon: "IPHONE-ROUTE",
    },
    {
      title: "Unique, vibrant, minimal prints",
      description:
        "Printed on high quality aluminum dibond material for a minimal frameless look, and a robust product that can withstand humid environments like kitchens and bathrooms",
      icon: "SIZE",
    },
    {
      title: "30+ Map Styles and presets",
      description:
        "From minimalist to vintage, find the perfect style for your adventure. Start with one of our carefully crafted presets and add your own touches.",
      icon: "MAP",
    },
    {
      title: "Unlimited Customization",
      description:
        "Add photos, change colors, fonts, labels, and more to make it truly yours",
      icon: "PENCIL",
    },
    {
      title: "UK Shipping Included",
      description:
        "No hidden costs at checkout.  The price you see when you choose your size is the price you pay",
      icon: "DOWNLOAD",
    },
  ];

  return (
    <div className={styles.sectionContainer}>
      <h2 className={styles.sectionTitle}></h2>
      <div className={styles.benefitsContainer}>
        {benefits.map((benefit, index) => (
          <div key={index} className={styles.benefitCard}>
            <div className={styles.benefitIcon}>
              <UIIcon iconName={benefit.icon} variant="SELECTED" size={30} />
            </div>
            <h3 className={styles.benefitTitle}>{benefit.title}</h3>
            <p className={styles.benefitDescription}>{benefit.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
